import { useCallback } from 'react'

import { useCalendarConfig } from '../../../providers/CalendarConfigProvider'
import { useRecurrenceDispatch } from '../../../providers/StateProvider'
import { parseRecurrenceWhen } from './utils/parseRecurrenceWhen.ts'
import { SelectChangeEvent } from '@mui/material'

export function useOnChange() {
  const dispatch = useRecurrenceDispatch()
  const calendarConfig = useCalendarConfig()

  return useCallback(
    (event: SelectChangeEvent<string>) => {
      const recurrenceWhen = parseRecurrenceWhen(event.target.value)

      dispatch({
        type: 'recurrenceWhen:change',
        recurrenceWhen,
        calendarConfig,
      })
    },
    [dispatch, calendarConfig],
  )
}
